import { Injectable } from '@angular/core';
import { ApiEntityStore } from '@core/api/api-entity-store';
import { Organization } from '@core/models/organization.model';
import { ActiveState, EntityState, StoreConfig } from '@datorama/akita';

export interface OrganizationState extends EntityState<Organization>, ActiveState {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'organizations', resettable: true })
export class OrganizationStore extends ApiEntityStore<OrganizationState> {
  constructor() {
    super();
  }
}
